import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  border: 3px solid #fff;
  border-top: 2px solid #000;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 0.8s linear infinite;
  margin-right: 8px;
`

const StyledButton = styled.button`
  font-size: 18px;
  font-family: Proxima-nova;
  display: flex !important;
  justify-content: center;
  text-transform: uppercase;
  color: ${(props) => (props.disabled ? '#fff' : '#fff')};
  background: ${(props) => (props.disabled ? '#000' : '#000')};
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  padding: 12px 32px;
  display: block;
  text-align: center;
  width: 100%;
  border: 1px solid #000;
  border-radius: 0px;

  &:hover {
    background: #000;
  }
`

const LoadingButton = ({ isLoading, children, ...rest }) => {
  return (
    <StyledButton disabled={isLoading} {...rest}>
      {isLoading && <Spinner />}
      {children}
    </StyledButton>
  )
}

export default LoadingButton
